// Bridges BoardState's 'viewport-changed' events into the central
// `WhiteboardBus.viewport$` BehaviorSubject. One of four state-stream adapters
// whitelisted by the `single-publisher-invariant` ESLint rule (file suffix match).
//
// Per T0.3 finding: viewport mutations flow through the direct BoardState API
// (`state.setViewport(vp)` -> `state.emit('viewport-changed', ...)`), not via
// DOM CustomEvents. The adapter therefore subscribes through `state.on(...)`.
//
// `dispose()` unsubscribes the listener — MUST be called from the host's
// `disconnectedCallback` BEFORE `bus.destroy()` (TR9 / FC-6 ordering).

import type { BoardState } from '../state/board-state.js';
import type { WhiteboardBus } from './whiteboard-bus.js';

type Unsubscribe = () => void;

export class ViewportBusAdapter {
    readonly #unsubscribe: Unsubscribe;

    constructor(state: BoardState, bus: WhiteboardBus) {
        this.#unsubscribe = state.on('viewport-changed', ({ viewport }) => {
            bus.viewport$.next(viewport);
        });
    }

    /** Remove the BoardState listener. Idempotent. */
    dispose(): void {
        this.#unsubscribe();
    }
}
